import React, { Component } from 'react';
import {Doughnut} from 'react-chartjs-2';
import 'chart.piecelabel.js';
import Lang from '../../../i18n'
import { withRouter } from 'react-router-dom'
var classNames = require('classnames');

class PieChart extends Component{
  render() {
    const styles = this.props.styles;
    const data = this.props.data;
    const currency = this.props.currency;
    var labelsArray = [];
    var dataArray = [];
    var totals = Number(0.00); // Umsatz
    for (let index = 0; index < data.length; index++) {
      const amount = Number(parseFloat(data[index].amount).toFixed(2));
      totals = Number(parseFloat(amount+totals).toFixed(2));
      labelsArray.push(
        data[index].title
      )
      dataArray.push(
        amount
      )
    }
    const pieData = {
      labels: labelsArray,
      datasets: [{
        data: dataArray,
        backgroundColor: [
          'rgba(245,166,35,1)',
          'rgba(13,46,160,1)',
          'rgba(125,156,94,1)',
        ]
      }],
      
    }
    const chartOptions = {
        pieceLabel: {
          render: 'percentage',
          precision: 2,
          fontSize: 15,
          fontColor: '#fff'
        },
        legend: {
          display: false
        }
    }
    return(
      <div className={classNames(styles.inputItem, styles.modulRingdiagram)}>
        <section className={styles.pieArea}>
          <div className={classNames(styles.pieParticluars, styles.pieInvestment)}>
            <span className={styles.bottom}>{Lang.translate('calculator:investment', this.props.location.pathname)}</span>
            <span className={styles.pieNumber}>{Number(dataArray[1]).toLocaleString('de-DE')}</span>
            <span>{currency.symbol}</span>
          </div>
          <div className={classNames(styles.pieParticluars, styles.pieDeckung)}>
            <span className={styles.bottom}>{Lang.translate('calculator:contributionMargin', this.props.location.pathname)}</span>
            <span className={styles.pieNumber}>{Number(dataArray[2]).toLocaleString('de-DE')}</span>
            <span>{currency.symbol}</span>
          </div>
          <div className={classNames(styles.pieParticluars, styles.pieTotals)}>
            <span className={styles.bottom}>{Lang.translate('calculator:turnover', this.props.location.pathname)}</span>
            <span className={styles.pieNumber}>{totals.toLocaleString('de-DE')}</span>
            <span>{currency.symbol} / {Lang.translate('calculator:year', this.props.location.pathname)}</span>
          </div>
          <Doughnut
            data={pieData}
            width={456}
            height={330}
            options={chartOptions}
          />
          <aside>
            <div className={classNames(styles.pieParticluars, styles.pieCosts)}>
              <span className={styles.bottom}>{Lang.translate('calculator:variableCosts', this.props.location.pathname)}</span>
              <span className={styles.pieNumber}>{Number(dataArray[0]).toLocaleString('de-DE')}</span>
              <span>{currency.symbol}</span>
            </div>
          </aside>
        </section>
      </div>
    );
  }
}

export default withRouter(PieChart);



// WEBPACK FOOTER //
// ./src/components/calculator/charts/c_pie_chart.js